/**
 * Google Agenda (0152) do lado da tela: a conexão de quem está na sessão e o que
 * dizer quando a pessoa volta do Google.
 */

export type SituacaoDaAgendaGoogle = 'conectada' | 'desconectando' | 'revogada';

export interface AgendaGoogle {
    email: string | null;
    situacao: SituacaoDaAgendaGoogle;
    conectadaEm: string | null;
    ultimoErro: string | null;
    /** Mudanças ainda a caminho do Google. */
    naFila: number;
}

export interface AvisoDaVolta {
    title: string;
    description: string;
    tone?: 'success' | 'danger';
}

/** A borda devolve a pessoa ao app com `?google-agenda=<resultado>`. */
export const AVISOS_DA_VOLTA: Record<string, AvisoDaVolta> = {
    conectada: {
        title: 'Google Agenda conectada',
        description: 'Seus atendimentos começam a aparecer na sua agenda em alguns minutos.',
        tone: 'success',
    },
    cancelada: {
        title: 'Conexão cancelada',
        description: 'Nada foi conectado. A agenda Google continua como estava.',
    },
    'sem-permissao': {
        title: 'Faltou a permissão da agenda',
        description: 'Na tela do Google, marque a opção de ver e editar os eventos da sua agenda e conecte de novo.',
        tone: 'danger',
    },
    erro: {
        title: 'Não foi possível conectar a agenda',
        description: 'Tente de novo em instantes. Se continuar, fale com o suporte da Fórmula MED.',
        tone: 'danger',
    },
};
